import BaseList from './../../MyLeaves/List';
import Item from './Item';
import RowItem from './RowItem';

export default class List extends BaseList {
    getItem(leave: any) { return (<Item onRefresh={this.onRefresh} leave={leave} />); }
    getRowItem(leave: any) { return (<RowItem onRefresh={this.onRefresh} leave={leave} />); }
}